import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalizeFormat',
})
export class NormalizeFormatPipe implements PipeTransform {
  transform(format: string): string {
    if (!format) return 'plaintext';
    if (format.toLowerCase() === 'raw') return 'json';
    return format.toLowerCase();
  }
}
